module.exports = __webpack_public_path__ + "static/media/one-half.57ec26bb.svg";